import React from "react";
import Dropdown from "../../../../../../components/Inputs/Dropdown";
import { credTypes, dynamicQRTypes, formats, staticQRTypes } from "../helper";
import TextInput from "../../../../../../components/Inputs/TextInput";
import { emailVerification } from "../../../../../../utils/formValdations";


//mode=1 (Add), mode=2 (Edit)
const GenerateNewCredential = ({ mode = 1, selectedFormat, setSelecetdFormat, email, setEmail, userName, setUserName, credentialId, setCredentialId, assignmentMethod, qrMode, selectedQRType, setSelecetdQRType, credentialType }) => {
    return (
        <div className='column' style={{ gap: '1rem', width: '100%' }}>
            <div className='column' style={{ alignItems: 'start', width: '100%', gap: '0.5rem' }}>
                <TextInput
                    name="email"
                    error={(email && !emailVerification(email)) ? 'Please enter a valid email address' : ''}
                    placeholder="Email"
                    value={email}
                    onChange={(e) => { setEmail(e?.target?.value?.trim()) }}
                />
            </div>
            <div className='column' style={{ alignItems: 'start', width: '100%', gap: '0.5rem' }}>
                <TextInput
                    name="name"
                    placeholder="Name"
                    value={userName}
                    onChange={(e) => { setUserName(e?.target?.value?.trimStart()) }}
                />
            </div>
            {assignmentMethod?.id === 2 && <TextInput
                name="credentialId"
                placeholder="Credential ID"
                value={credentialId}
                type='number'
                onChange={(e) => { setCredentialId(e?.target?.value?.trim()) }}
            />}

            {(mode === 2 && credentialType?.id === "qr") && <Dropdown
                key={`qr_type_${selectedQRType?.id}`}
                placeholder="QR Type"
                value={selectedQRType.name || undefined}
                onChange={(data) => {
                    setSelecetdQRType(data);
                }}
                data={qrMode === "1" ? staticQRTypes : dynamicQRTypes}
            />}

            <Dropdown
                disabled={true}
                placeholder="Format"
                value={selectedFormat.name}
                onChange={(data) => {
                    setSelecetdFormat(data)
                }}
                data={formats}
            />

        </div>
    )
};

export default GenerateNewCredential;